import Skeleton from '@mui/material/Skeleton'
import React, { FC, useContext } from 'react'

import { AppContext } from 'providers/context/App'
import { HYDRAFACIAL_IDS } from 'utils/constants/Helpers'
import { HeaderTheme } from '../../../utils/types/appTypes'

import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg'
import { ReactComponent as BackIcon } from '../../../assets/icons/leftarrowicon-white.svg'
import './commonHeader.scss'

interface Props {
  backToFunction?: () => void
  theme?: HeaderTheme
  hideFacialName?: boolean
  hideTitle?: boolean
  closeButton?: boolean
  title?: string
  loading?: boolean
}

const CommonHeader: FC<Props> = ({
  backToFunction,
  theme,
  hideFacialName,
  hideTitle,
  closeButton,
  title,
  loading,
}) => {
  const { appMasterData } = useContext(AppContext)

  let pageTitle: string

  if (appMasterData?.isMicroNeedling && !hideFacialName) {
    pageTitle = 'BOOK A MICRONEEDLING FACIAL'
  } else if (appMasterData?.isLaserFacial && !hideFacialName) {
    pageTitle = 'BOOK A LASER FACIAL'
  } else if (
    HYDRAFACIAL_IDS.includes(appMasterData?.category?.categoryId) &&
    !hideFacialName
  ) {
    pageTitle = 'BOOK A HYDRAFACIAL'
  } else {
    pageTitle = title ?? 'BOOK A FACIAL'
  }

  return (
    <div
      className={`title-box1 ${
        theme && theme === HeaderTheme.NEUTRAL_TERTIARY
          ? 'neutral-tertiary-background'
          : ''
      }
      ${theme && theme === HeaderTheme.ORANGE ? 'light-orange-background' : ''}
      `}
    >
      <div className="upper-main-head1">
        {backToFunction && (
          <div className="back-box">
            <BackIcon
              className="back-icon"
              onClick={backToFunction}
              data-testid="back-icon"
            />
          </div>
        )}
        {!hideTitle && (
          <span>
            {loading ? (
              <Skeleton
                variant="text"
                width={175}
                height={50}
                style={{ margin: '0 auto' }}
              />
            ) : (
              pageTitle
            )}
          </span>
        )}
        {closeButton && (
          <div className="close-box">
            <CloseIcon
              className="close-icon"
              onClick={backToFunction}
              data-testid="close-icon"
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default React.memo(CommonHeader)
